import { Component } from "../component"
import { iterable } from "../helpers/iterable"

export class SectionPageNavigation extends Component {
  constructor(props) {
    super(props)

    this.dynamicClasses = {
      active: "-active",
    }
  }

  ui() {
    return {}
  }

  createLinks() {
    const titles = document.querySelectorAll("[data-page-navigation-handle]")
    const selects = document.querySelectorAll(".page-navigation-select")
    const names = []

    iterable(titles).forEach((title, index) => {
      const name = title.textContent
      const handle = title.dataset.pageNavigationHandle
      const link = document.createElement("a")
      link.textContent = name
      link.setAttribute("href", `#${handle}`)
      link.classList.add("section-page-navigation-link")
      link.addEventListener("click", (e) => {
        const top = window.scrollY
        window.location.hash = `#${handle}`
        window.scrollTo(0, top)
        this.activateLink(index)
        e.preventDefault()
      })
      this.$el.appendChild(link)
      names.push({
        name,
        handle,
      })
    })

    iterable(selects).forEach((select) => {
      names.forEach(({ name, handle }) => {
        const option = document.createElement("option")
        option.textContent = name
        option.value = `#${handle}`
        if (select.dataset.value === handle) {
          option.setAttribute("selected", "selected")
        }
        select.appendChild(option)
      })

      select.addEventListener("change", () => {
        const top = window.scrollY
        window.location.hash = select.value
        const value = select.value
        window.scrollTo(0, top)

        iterable(selects).forEach((select) => {
          iterable(select.children).forEach((option) => {
            if (option.value === value) {
              option.setAttribute("selected", "selected")
            } else {
              option.removeAttribute("selected")
            }
          })
        })
      })
    })
  }

  activateLink(arg) {
    const { active } = this.dynamicClasses
    let activeLinkIndex

    if (typeof arg === "number") {
      activeLinkIndex = arg
    } else {
      const link = this.$el.querySelector(
        `[href="#${window.location.hash.substr(1)}"]`
      )
      activeLinkIndex = Array.from(this.$el.children).indexOf(link)
    }

    iterable(this.$el.children).forEach((link, linkIndex) => {
      link.classList.toggle("-active", linkIndex === activeLinkIndex)
    })
  }

  created() {
    this.createLinks()

    if (window.location.hash.length <= 2) {
      window.location.hash = this.$el.children[0].getAttribute("href")
    }
    this.activateLink()

    const timeouts = [1, 100, 200, 500]
    timeouts.forEach((timeout) => {
      setTimeout(() => {
        window.scrollTo(0, 0)
      }, timeout)
    })
  }
}
